import { Box, Typography } from "@mui/material";
import React from "react";
import moment from "moment";

const NotificationCard = ({ data }) => {
  return (
    <Box
      p={2}
      bgcolor={"#EDF1F566"}
      borderRadius={2}
      border={"1px solid #dfe2e5"}
      sx={{
        cursor:"pointer"
      }}
    >
      <Typography variant="h6">{data?.title}</Typography>
      <Typography variant="body1" color={"text.coolGrey"}>
        {data?.body}
      </Typography>
      {/* Display time ago using moment */}
      <Typography variant="caption" color={"text.secondary"}>
        {moment(data?.createdAt).format('YYYY-MMM-DD hh:mm a')}
        {/* {moment(data?.createdAt, "YYYY-MM-DD HH:mm:ss").fromNow()} */}
      </Typography>
    </Box>
  );
};

export default NotificationCard;
